export default __webpack_public_path__ + "media/images/new_year/header_1920x1080-00762624f01212efeb2d8a45ff89723b.webp";